import { render, staticRenderFns } from "./FoodSafetyInspection.vue?vue&type=template&id=1f3699f2&scoped=true"
import script from "./FoodSafetyInspection.vue?vue&type=script&lang=js"
export * from "./FoodSafetyInspection.vue?vue&type=script&lang=js"
import style0 from "./FoodSafetyInspection.vue?vue&type=style&index=0&id=1f3699f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3699f2",
  null
  
)

export default component.exports